<template>
  <div class="input-group checkbox">
    <div class="input-checkbox">
      <label :for="nameProperty" :class="hasDisabled ? 'readonly' : ''"
        ><slot />
        <span v-if="!isRadio" class="custom-checkbox"
          ><img src="@/assets/images/Icon/Checked.svg" alt="Checked" /></span
        ><span class="checkbox-name">{{ title }}</span></label
      >
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "nameProperty", "hasDisabled", "isRadio"],
};
</script>

<style lang="scss" scoped>
label {
  &.readonly {
    .custom-checkbox {
      filter: brightness(0.9) opacity(0.5);
    }
    .checkbox-name {
      color: #d1d1d1;
    }
  }
}
</style>
